export enum Product {
  PAYROLL = "payroll",
  PAYROLL_AND_BENEFITS = "payroll_and_benefits",
  BENEFITS = "benefits"
}
